import React from 'react';
import { IconProps } from './types';

export const LeftChevron = ({ ...svgProps }: IconProps) => (
  <svg
    {...svgProps}
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 1L2 8L9 15"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
